var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("logo", {
        staticClass: "header-logo",
        attrs: { linked: !_vm.oneTimeAccess }
      }),
      _vm._v(" "),
      _vm.authenticated
        ? _c(
            "div",
            { staticClass: "links" },
            [
              _c(
                "a",
                { staticClass: "header-link", on: { click: _vm.submitLogout } },
                [_vm._v("Logout")]
              ),
              _vm._v(" "),
              !_vm.oneTimeAccess
                ? _c(
                    "a",
                    {
                      staticClass: "header-link button-header-link",
                      on: { click: _vm.newProvider }
                    },
                    [_vm._v("Create")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.oneTimeAccess
                ? _c(
                    "router-link",
                    {
                      staticClass: "header-link",
                      attrs: { tag: "a", to: { name: "search" } }
                    },
                    [_vm._v("Search")]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a61c582", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a61c582","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/navBar.vue
// module id = 86
// module chunks = 0